import React, { createContext, useState, useEffect } from 'react';
import {API_URL, WHITELABEL_ID} from '../constants';
import axios from 'axios';
import Spinner from "react-bootstrap/Spinner";


export const TruckTypesContext = createContext();

export const TruckTypesProvider = ({ children }) => {
    const [truckTypes, setTruckTypes] = useState(null);

    useEffect(() => {
        axios.get(`${API_URL}/api/wl/${WHITELABEL_ID}/public/truck_types`,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
               // console.log('Test', response.data);
                setTruckTypes(response.data);
            })
            .catch(err => console.error('Failed to load truck types:', err))
            .finally(() => {

            });
    }, []);

    return (
        <TruckTypesContext.Provider value={truckTypes}>
            {truckTypes ? children : (
                <div className="d-flex justify-content-center align-items-center">
                    <Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true"/>
                </div>
            )}
        </TruckTypesContext.Provider>
    );
};
